import { useCallback, useEffect, useState } from 'react'

const STORAGE_KEY = 'ipp-nav-v3-sidebar-collapsed'

const readInitialState = (): boolean => {
  if (typeof window === 'undefined') return false
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export const useSidebarCollapsedPersistence = (): [boolean, (next: boolean) => void] => {
  // SSR-safe: defer the read until after mount so server and first client
  // render agree (both produce `false`), then hydrate from localStorage.
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false)

  useEffect(() => {
    const stored = readInitialState()
    if (stored) setIsCollapsed(true)
  }, [])

  const setCollapsed = useCallback((next: boolean) => {
    setIsCollapsed(next)
    if (typeof window === 'undefined') return
    try {
      window.localStorage.setItem(STORAGE_KEY, String(next))
    } catch {
      // localStorage unavailable (private mode, quota); state is still
      // managed in memory for this session.
    }
  }, [])

  return [isCollapsed, setCollapsed]
}
